import Servicios from "../../Components/Servicios/Servicios";
import { serviciosCaptacion } from "../../Data/serviciosCaptacion";

function Captacion() {
  return (
    <Servicios
      etiqueta="CAPTACIÓN DE CLIENTES"
      titulo="Convertí personas interesadas en oportunidades reales."
      subtitulo="Creamos un circuito digital que conecta contenido, publicidad, formularios, WhatsApp y métricas."
      servicios={serviciosCaptacion.servicios}
      background={serviciosCaptacion.background}
    />
  );
}

export default Captacion;